module.exports = __webpack_public_path__ + "media/images/icon_list/invisible-a64c32782222ff3e95a952448f1a1112.svg";